import { useState } from "react";
import { useSelector } from "react-redux";

import HexCard from "../../../../../components/HexCard";
import HexTitle from "../../../../../components/HexTitle";

import { getLabel } from "../../../../../hooks/use-labels";

import DetailPreview from "../../../../../components/Preview/DetailPreview";
import { getStyle } from "../../../../../hooks/use-styles";

import HexModal from "../../../../../components/HexModal";
import HexMap from "../../../../../components/HexMap";

import { prepareDeliveryInformation } from "../cart-details-utils";

const DeliveryInformationCard = ({
  className,
  borderless,
  detail,
  titleClass,
  titleStyle,
}) => {
  const { deliveryType, deliveryAddress } = useSelector((state) => state.order);

  const deliveryInformationType = detail
    ? { ...detail.deliveryType, timeSlot: detail.deliveryDateTime }
    : deliveryType;

  const deliveryInformationAddress = detail?.deliveryAddress || deliveryAddress;

  const [map, openMap] = useState(false);

  const toggleMap = () => {
    openMap((prev) => !prev);
  };

  const renderMap = () => {
    if (!map) return null;

    const { latitude, longitude } = deliveryInformationAddress;

    return (
      <HexModal open={true} onClose={toggleMap} closable={true} modalClass="delivery-information-card-modal">
        <HexMap
          mapProps={{ latitude, longitude }}
          modal={true}
          onClose={toggleMap}
        />
      </HexModal>
    );
  };

  return (
    <HexCard
      className={`content-card  ${!borderless && "card-bottom-divider"} ${
        className || ""
      }`}
    >
      {renderMap()}
      <HexTitle
        title={getLabel("deliveryInformation")}
        className={titleClass || "font-18-regular-500-lh-22 mb-12"}
        titleStyle={titleStyle}
      />

      <DetailPreview
        inlineFlex={true}
        className={"mb-8"}
        detailInfo={
          deliveryInformationType && deliveryInformationAddress
            ? prepareDeliveryInformation(
                deliveryInformationType,
                deliveryInformationAddress,
                toggleMap
              )
            : []
        }
        labelClass={"font-12-normal-400-lh-14 capitalize"}
        valueClass={"font-12-normal-400-lh-14 capitalize"}
        labelStyle={{ color: getStyle("secondaryGray") }}
        valueStyle={{ color: getStyle("primaryBlack") }}
      />
    </HexCard>
  );
};

export default DeliveryInformationCard;
